export function moneyFormat(x, currency, adonClasses) {
  let formated = x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return (
    <>
      <span dir="ltr" className={adonClasses}>
        {formated}
      </span>
      {currency !== false && <span>{" تومان"}</span>}
    </>
  );
}

export default moneyFormat;
